import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionEft } from "../../../api/transaction-type";
import {
  salesOrderBillEftPaymentInfoTable,
  salesOrderBatchTransactionInfoTable,
  INVChargesTable,
  EftBTITable,
} from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Stack,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import {
  CustomCheckBox,
  CustomCheckBoxComp126,
} from "../../../components/CheckboxComp";

export default function BillPaymentEft({ tabIndexP }) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];

  const [rowData, setRowData] = useState([]);

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  useEffect(() => {
    if (user.token) {
      getTransactionEftData();
    }
  }, [user.token]);

  async function getTransactionEftData() {
    setLoading(true);
    try {
      const { data } = await getTransactionEft(user.token, {
        id: params.docNo,
      });
      setRowData(data.data.data[0]);
      return {
        rows: data.data.data,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      setLoading(false);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  console.log(rowData, "rowData");
  return (
    <>
      <Box className="viewDetilsBox">
        {/* {rowData.map((d, i) => ( */}
        <Grid container className="mb-2">
        {rowData?.electronic_payment === "F" ||
            rowData?.electronic_payment === "" ?(
            <Grid item xs={12} sm={6} md={6} className="m-b-10">
              <p className="tFormlabel">
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox  disabled />}
                    label="FOR ELECTRONIC PAYMENT PIFA RECORD"
                  />
                </FormGroup>
              </p>
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={6} className="m-b-10">
              <p className="tFormlabel">
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox checked disabled />}
                    label="FOR ELECTRONIC PAYMENT PIFA RECORD"
                  />
                </FormGroup>
              </p>
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={6} className="m-b-10">
            <p className="tFormlabel">ENTITY BANK (VENDOR)</p>
            <p className="tFormName">{rowData?.vendor_entity_bank}</p>
          </Grid>
          <Grid item xs={12} sm={6} md={6} className="m-b-10"></Grid>
          <Grid item xs={12} sm={6} md={6} className="m-b-10">
            <p className="tFormlabel">ENTITY BANK (EMPLOYEE)</p>
            <p className="tFormName">{rowData?.employee_entity_bank}</p>
          </Grid>
        </Grid>
        {/* ))} */}
        <Box
          px={2}
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-sub-bkg"
          >
            <Tab label="Batch Transaction Information" />
            {/* <Tab label="Bill EFT Payment Information" /> */}
          </Tabs>
          <TabPanel value={tabIndex} index={0}>
            {/*FAM Asset*/}
            <Box className="viewDetilsBox">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3} md={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Alternate Depreciation History">
                        Alternate Depreciation History
                      </MenuItem>
                      <MenuItem value="Custom Default View">
                        Custom Default View
                      </MenuItem>
                      <MenuItem value="Default View">Default View</MenuItem>
                      <MenuItem value="Depreciation History">
                        Depreciation History
                      </MenuItem>
                      <MenuItem value="FAM Accounting Method">
                        FAM Accounting Method
                      </MenuItem>
                      <MenuItem value="FAM Depreciation Method 1">
                        FAM Depreciation Method 1
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={3} md={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      BATCH TRANSACTION INFORMATION
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="FAM DEPRECIATION HISTORY"
                    >
                      <MenuItem value="all">All</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button">
                  New Batch Transaction Information{" "}
                </Button>
                <Button className="blue-button">Attach</Button>
                <Button className="blue-button">Customize View</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              getTableRows={undefined}
              columns={EftBTITable}
              perPage={5}
              refreshCounter={0}
            />
            {/*FAM Asset History*/}
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            {/*FAM Asset*/}
            <Box className="viewDetilsBox">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3} md={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Alternate Depreciation History">
                        Alternate Depreciation History
                      </MenuItem>
                      <MenuItem value="Custom Default View">
                        Custom Default View
                      </MenuItem>
                      <MenuItem value="Default View">Default View</MenuItem>
                      <MenuItem value="Depreciation History">
                        Depreciation History
                      </MenuItem>
                      <MenuItem value="FAM Accounting Method">
                        FAM Accounting Method
                      </MenuItem>
                      <MenuItem value="FAM Depreciation Method 1">
                        FAM Depreciation Method 1
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={3} md={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      BILL EFT PAYMENT INFORMATION
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="FAM DEPRECIATION HISTORY"
                    >
                      <MenuItem value="all">All</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button">
                  New Bill EFT Payment Information
                </Button>
                <Button className="blue-button">Attach</Button>
                <Button className="blue-button">Customize View</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              getTableRows={undefined}
              columns={INVChargesTable}
              perPage={5}
              refreshCounter={0}
            />
            {/*FAM Asset History*/}
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
